import * as THREE from 'three';
import gsap from 'gsap';

export class Scene {
    
    setUp(e) {
  
      this.e = e;
      this.test = false;
      this.action = "wait";

      this.isDragging = false;
      this.dragStartX = 0;
      this.dragRotationTarget = 0;
      this.dragRotationCurrent = 0;

    }
  
    buildScene(){

      const canvas = this.e.renderer.domElement;

      canvas.style.pointerEvents = "auto";
  
      // Prevent native drag behaviors (but not mousedown)
      ["dragstart", "contextmenu"].forEach(eventType => {
        canvas.addEventListener(eventType, (e) => {
          e.preventDefault();
          e.stopPropagation();
          return false;
        });
      });
  
      // Mouse drag support
      canvas.addEventListener("mousedown", (e) => {
        console.log("mousedown");
        if (this.action === "pon") {
          this.isDragging = true;
          this.dragStartX = e.clientX;
        }
      });
  
      window.addEventListener("mouseup", () => {
        this.isDragging = false;
      });
  
      window.addEventListener("mousemove", (e) => {
        if (this.isDragging && this.action === "pon") {
          const deltaX = e.clientX - this.dragStartX;
          this.dragStartX = e.clientX;
          this.dragRotationTarget += deltaX * 0.01;
        }
      });
  
      // Touch drag support
      canvas.addEventListener("touchstart", (e) => {
        if (this.action === "pon") {
          this.isDragging = true;
          this.dragStartX = e.touches[0].clientX;
        }
      });
  
      window.addEventListener("touchend", () => {
        this.isDragging = false;
      });
  
      window.addEventListener("touchmove", (e) => {
        if (this.isDragging && this.action === "pon") {
          const deltaX = e.touches[0].clientX - this.dragStartX;
          this.dragStartX = e.touches[0].clientX;
          this.dragRotationTarget += deltaX * 0.01;
        }
      });


      //-------------------------

      this.mainCont = new THREE.Group();
      this.e.scene3D.add(this.mainCont)

      this.dl = new THREE.DirectionalLight(0xffffff, 3);
      this.dl.position.x=12*3;
      this.dl.position.z=26*3;
      this.dl.position.y=26*3;
      this.mainCont.add(this.dl);

      // this.dl_shad = new THREE.DirectionalLight(0xffffff, 1);
      // this.dl_shad.position.x=12*3;
      // this.dl_shad.position.z=26*3;
      // this.dl_shad.position.y=26*3;
      // this.mainCont.add(this.dl_shad);

      // this.dl_shad.castShadow=true;

      // this.dl_shad.shadow.mapSize.width = 1024;
      // this.dl_shad.shadow.mapSize.height = 1024;
      // // this.dl_shad.shadow.bias = .001;
      
      // this.e.sSize = 11;
      // this.dl_shad.shadow.camera.near = 0.1; 
      // this.dl_shad.shadow.camera.far = 180;
      // this.dl_shad.shadow.camera.left = -this.e.sSize;
      // this.dl_shad.shadow.camera.right = this.e.sSize;
      // this.dl_shad.shadow.camera.top = this.e.sSize;
      // this.dl_shad.shadow.camera.bottom = -this.e.sSize;
      // this.dl_shad.shadow.radius = 2;

      // const shadowHelper = new THREE.CameraHelper(this.dl_shad.shadow.camera);
      // this.mainCont.add(shadowHelper);

      // ambient light

      this.ambLight = new THREE.AmbientLight( 0xffffff, 1 );
      this.mainCont.add( this.ambLight );

      //---PLAYER------------------------------------------------------------------------------------------------------

      this.playerCont = new THREE.Group();
      this.mainCont.add(this.playerCont)
      this.playerCont.position.y=0;
      this.playerCont.position.z=0;
      this.playerCont.position.x=0;

      //---SCENE------------------------------------------------------------------------------------------------------

      var geometry = new THREE.PlaneGeometry(20,20);
      var material = new THREE.MeshBasicMaterial({ color: 0x000000, transparent: true, opacity: 0 });
      this.darkPlane = new THREE.Mesh(geometry, material);
      this.darkPlane.position.z=-5;
      this.mainCont.add(this.darkPlane);

      var material = new THREE.MeshBasicMaterial({ color: 0x3dcd58, transparent: true, opacity: 0 });
      this.darkPlane2 = new THREE.Mesh(geometry, material);
      this.darkPlane2.position.z=5;
      this.mainCont.add(this.darkPlane2);

      this.downAmount = -4.3;

      //--------------------------------------------------------

      this.coverMaterials = [];

      this.pulsePanel = this.e.pulsePanel.clone();
      this.pulsePanel.scale.x = this.pulsePanel.scale.y = this.pulsePanel.scale.z = 4;
      this.pulsePanel.position.y=this.downAmount;
      this.mainCont.add(this.pulsePanel);
      
      this.pulsePanel.position.x=2;
      this.pulsePanel.position.y=-2.5;
      this.pulsePanel.position.z=-8;

      this.pulsePanel.traverse((object) => {

        if ( object.isMesh ){

          // if(object.material.name==="greenLight"){

          //   object.material = new THREE.MeshBasicMaterial({ color: 0x00ff00});

          // }else 
          
          if(object.material.name==="greenGlass2"){

            object.material = new THREE.MeshBasicMaterial({ transparent: true, opacity: .85, color: 0x007a25});

          }else if(object.name==="flange"){

            this.flange = object;
            this.newmat = this.flange.material.clone();
            this.flange.material = this.newmat;
            this.flange.material.transparent = true;
            this.flange.material.opacity = 0;

          }else if(object.material.name==="silver"){

            this.changeMaterial = object.material;
            object.material.envMap = this.e.reflectionTexture;

          }

        }else{
          
          if(object.name==="frontDoor"){

            this.frontDoor = object;

          }else if(object.name==="cover"){

            this.cover = object;

            object.traverse((object2) => {

              if ( object2.isMesh ){

                this.newMaterial = object2.material.clone();
                this.newMaterial.transparent = true;

                object2.material = this.newMaterial;
                this.coverMaterials.push(object2.material);

              }

            });

          }

        }

      });

      //--------------------------------------------------------

      this.emMaterials = [];

      this.energyMonitor = this.e.energyMonitor.clone();
      this.energyMonitor.scale.x = this.energyMonitor.scale.y = this.energyMonitor.scale.z = .2;
      this.energyMonitor.rotation.y = this.e.u.ca(230);
      this.energyMonitor.position.y=-1000;
      this.mainCont.add(this.energyMonitor);

      this.energyMonitor.traverse((object) => {

        if(object.material!==undefined){
            
          this.emMaterials.push(object.material);
          object.material.transparent=true;

        }

      });
      
      //--------------------------------------------------------

      this.qoMaterials = [];

      this.qo = this.e.bcs.clone();
      this.qo.scale.x = this.qo.scale.y = this.qo.scale.z = 4.2;
      this.qo.rotation.y = this.e.u.ca(30);
      
      this.qo.position.x=.45;
      this.qo.position.y=-.725;
      this.qo.position.z=.05;
      
      this.qo.startx=this.qo.position.x
      this.qo.starty=this.qo.position.y
      this.qo.startz=this.qo.position.z
      this.qo.startrot=this.qo.rotation.y

      this.mainCont.add(this.qo);

      this.qo.position.y=-1000;

      // this.qo.traverse((object) => {

      //   if(object.material!==undefined){
              
      //     this.qoMaterials.push(object.material);
      //     object.material.transparent=true;

      //   }

      // });
      
      //--------------------------------------------------------

      this.ponMaterials = [];

      this.pon = this.e.pon.clone();
      this.pon.scale.x = this.pon.scale.y = this.pon.scale.z = .1;
      this.pon.rotation.y = this.e.u.ca(230);

      this.pon.position.x=.2;
      this.pon.position.y=.55+.1;
      
      this.pon.startx=this.pon.position.x
      this.pon.starty=this.pon.position.y
      this.pon.startz=this.pon.position.z
      this.pon.startrot=this.pon.rotation.y

      this.pon.position.y=-1000;

      this.mainCont.add(this.pon);

      //--------------------------------------------------------

      this.breakerMaterials = [];

      this.breaker = this.e.breaker.clone();
      this.breaker.scale.x = this.breaker.scale.y = this.breaker.scale.z = .1;
      this.breaker.rotation.y = this.e.u.ca(230);

      this.breaker.position.x=.2;
      this.breaker.position.y=.45+.1;
      
      this.breaker.startx=this.breaker.position.x
      this.breaker.starty=this.breaker.position.y
      this.breaker.startz=this.breaker.position.z
      this.breaker.startrot=this.breaker.rotation.y

      this.breaker.position.y=-1000;

      this.mainCont.add(this.breaker);

      // this.breaker.traverse((object) => {

      //   if(object.material!==undefined){
              
      //     this.breakerMaterials.push(object.material);
      //     object.material.transparent=true;

      //   }

      // });
      
      //--------------------------------------------------------

      this.breaker60Materials = [];

      this.breaker60 = this.e.breaker60.clone();
      this.breaker60.scale.x = this.breaker60.scale.y = this.breaker60.scale.z = .1;
      this.breaker60.rotation.y = this.e.u.ca(230);

      this.breaker60.position.x=.2;
      this.breaker60.position.y=.33+.1;

      this.breaker60.startx=this.breaker60.position.x
      this.breaker60.starty=this.breaker60.position.y
      this.breaker60.startz=this.breaker60.position.z
      this.breaker60.startrot=this.breaker60.rotation.y
      
      this.breaker60.position.y=-1000;

      this.mainCont.add(this.breaker60);

      // this.breaker60.traverse((object) => {

      //   if(object.material!==undefined){
              
      //     this.breaker60Materials.push(object.material);
      //     object.material.transparent=true;

      //   }

      // });
      
      //--------------------------------------------------------

      var geometry = new THREE.PlaneGeometry(1.8,5.55);
      var material = new THREE.MeshBasicMaterial({ color: 0xff0000, transparent: true, opacity: .4, map: this.e.shadows });
      this.shadowPlane = new THREE.Mesh(geometry, material);
      this.mainCont.add(this.shadowPlane);

      this.shadowPlane.position.x=2.15;
      this.shadowPlane.position.y=0;
      this.shadowPlane.position.z=-7.9;

      //--------------------------------------------------------

      this.count=0;
      this.action="wait"

      this.outTime=.2;
      this.innerRotTime=4;

      document.addEventListener("click", () => {

        if(this.action==="wait"){
          this.action="start"
        }
        
      })

      this.isPaused=false;
      this.buttonType="pause"

      document.getElementById("pauseBut").addEventListener("click", () => {

        // console.log(this.buttonType);

        if(this.buttonType==="pause"){

          if(this.isPaused===false){
            this.isPaused=true;
            gsap.globalTimeline.pause();
            document.getElementById("pauseBut").innerHTML = "resume";
          }else{
            this.isPaused=false;
            gsap.globalTimeline.resume();
            document.getElementById("pauseBut").innerHTML = "pause";
          }
          
        }else if(this.buttonType==="continue"){

          this.continuePress=true;

        }

      });

      this.myTextLabel = document.getElementById("myTextLabel");

      this.pauseBut = document.getElementById("pauseBut");
      this.continuePress = false;

    }

    buttonChange(){

      if(this.buttonType==="pause"){

        this.pauseBut.innerHTML = "pause";
        this.pauseBut.backgroundColor = "green";

      }else if(this.buttonType==="continue"){

        this.pauseBut.innerHTML = "continue";
        this.pauseBut.backgroundColor = "#555555";

      }

    }

    update(){

      if (this.action === "pon" && this.pon) {
        this.dragRotationCurrent = this.e.u.lerp(
          this.dragRotationCurrent,
          this.dragRotationTarget,
          0.1
        );
      
        // Clamp both values to range -2π to 2π
        const maxRotation = Math.PI * 1;
        const minRotation = -Math.PI * 1;
      
        this.dragRotationCurrent = THREE.MathUtils.clamp(this.dragRotationCurrent, minRotation, maxRotation);
        this.dragRotationTarget = THREE.MathUtils.clamp(this.dragRotationTarget, minRotation, maxRotation);
      
        this.pulsePanel.rotation.y = this.dragRotationCurrent;
      }
  
      if (this.action === "fade wait") {
        this.count += this.e.dt;
        if (this.count > 2) {
          // this.count = 0;
          this.e.renderer.domElement.style.pointerEvents = "auto";
          // this.action = "pon";
        }
      }
  
      if (this.action === "hide wait") {
        this.count += this.e.dt;
        if (this.count > 0.5) {
          this.count = 0;
          this.action = "wait";
          this.isDragging = false;
          this.e.renderer.domElement.style.pointerEvents = "none";
        }
      }

      this.tweenInSpeed = 1;
      this.spinSpeed = 5;

      if(this.action==="wait"){

        //

      }else if(this.action==="start"){

        this.count=0;

        this.dragRotationTarget=0;

        gsap.to(this.pulsePanel.position, { duration: this.tweenInSpeed, x:0, z: 0, y:-2.5, ease: "sine.out" });

        this.flange.material.opacity=1;
        // gsap.to(this.shadowBot.material, { duration: this.tweenInSpeed/4, opacity: 0, ease: "sine.out" });

        document.getElementById("pauseBut").innerHTML = "pause";
        document.getElementById("pauseBut").style.pointerEvents = "auto";
        // gsap.to(document.getElementById("pauseBut"), { duration: this.tweenInSpeed/4, opacity: 1, ease: "linear" });

        gsap.to(this.shadowPlane.material, { duration: .25, opacity: 0, ease: "linear" });
        gsap.to(this.darkPlane.material, { duration: 1, delay: .5, opacity: 0.8, ease: "linear" });
        this.action="start wait";

      }else if(this.action==="start wait"){

        this.count+=this.e.dt;
        if(this.count>this.tweenInSpeed){

          this.count=0;
          this.action="spin";

        }

      }else if(this.action==="spin"){

        if(this.test===true){
          this.spinSpeed=.5;
        }

        gsap.to(this.pulsePanel.rotation, { duration: this.spinSpeed, y: this.e.u.ca(360), ease: "sine.inOut" });
        this.action="spin wait";

      }else if(this.action==="spin wait"){

        if(this.isPaused===false){
          this.count+=this.e.dt;
        }

        if(this.count>this.spinSpeed || this.test===true){

          this.count=0;

          for(var i=0; i<this.coverMaterials.length; i++){

            this.coverMaterials[i].opacity = 1;

          }
  
          gsap.to(this.frontDoor.rotation, { duration: 2, y: this.e.u.ca(160), ease: "sine.out" });
          this.action="open"
          
        }

     
      }else if(this.action==="open"){

        this.action="open wait"
          
      }else if(this.action==="open wait"){

        if(this.isPaused===false){
          this.count+=this.e.dt;
        }

        if(this.count>2 || this.test===true){

          this.count=0;

          this.action="fade"
          
        }

      }else if(this.action==="fade"){

        console.log("fade")

        for(var i=0; i<this.coverMaterials.length; i++){

          gsap.to(this.coverMaterials[i], { duration: .5, opacity: 0, ease: "linear" });

        }

        this.isPaused=false;
        this.count=0;
        this.action="fade wait";

      }else if(this.action==="fade wait"){

        if(this.isPaused===false){
          this.count+=this.e.dt;
        }

        console.log("--"+this.count);

        if(this.count>2){

          console.log("------------------------------")
          console.log("ppp")
          console.log("------------------------------")

          this.count=0;

          this.buttonType="continue";
          this.buttonChange();

          document.getElementById("dragMe").style.opacity = "1";

          this.action="pon"

          // if(this.test===true){
            // this.action="qo"
            // this.action="test qo"
          
          // }
          
        }

        //-------------------------------------------------------------------------------------------------------------------------------------

      }else if(this.action==="pon"){

        if(this.continuePress===true){

          gsap.to(this.pulsePanel.rotation, { duration: 1, y: this.e.u.ca(30), ease: "sine.inOut" });

          this.continuePress=false;
          this.buttonType="pause";
          this.buttonChange();

          document.getElementById("dragMe").style.opacity = "0";

          this.action="pon prep"

        }

      }else if(this.action==="pon prep"){

        this.count+=this.e.dt;
        if(this.count>1){

          this.qo.position.y = this.qo.starty;

          this.breaker.position.x = this.breaker.startx;
          this.breaker.position.y = this.breaker.starty;
          this.breaker.position.z = this.breaker.startz;
          this.breaker.rotation.y = this.breaker.startrot;

          this.breaker60.position.x = this.breaker60.startx;
          this.breaker60.position.y = this.breaker60.starty;
          this.breaker60.position.z = this.breaker60.startz;
          this.breaker60.rotation.y = this.breaker60.startrot;

          this.pon.position.x = this.pon.startx;
          this.pon.position.y = this.pon.starty;
          this.pon.position.z = this.pon.startz;
          this.pon.rotation.y = this.pon.startrot;

          this.count=0;
          this.action="pon 1"

        }
        
      }else if(this.action==="pon 1"){

        this.energyMonitor.position.z=0;
        this.energyMonitor.position.y=-1000;

        gsap.to(this.pon.position, { duration: 1, x: 0, y: 0, z: 10, ease: "sine.out" });
        gsap.to(this.pon.rotation, { duration: 1, x: this.e.u.ca(20), ease: "sine.out" });
        gsap.to(this.pon.scale, { duration: 1, x: .2, y: .2, z: .2, ease: "sine.out" });

        // this.myTextLabel.innerHTML = "pon 20A";

        gsap.to(this.darkPlane2.material, { duration: 1, delay: .25, opacity: 0.95, ease: "linear" });

        this.action="pon wait"

      }else if(this.action==="pon wait"){

        if(this.isPaused===false){
          this.count+=this.e.dt;
        }

        if(this.count>2){

          this.count=0;
          this.action="pon2"
          
        }

      }else if(this.action==="pon2"){

        gsap.to(this.pon.rotation, { duration: this.innerRotTime, y: this.pon.rotation.y + this.e.u.ca(360), ease: "sine.inOut" });

        this.action="pon wait2"

      }else if(this.action==="pon wait2"){

        if(this.isPaused===false){
          this.count+=this.e.dt;
        }

        if(this.count>this.innerRotTime+1){

          this.count=0;
          this.action="pon3"

          this.buttonType="continue";
          this.buttonChange();
          
        }

      }else if(this.action==="pon3"){

        if(this.continuePress===true){

          this.continuePress=false;
          this.buttonType="pause";
          this.buttonChange();

          this.action="pon3 out"

        }

      }else if(this.action==="pon3 out"){

        gsap.to(this.darkPlane2.material, { duration: this.outTime, opacity: 0, ease: "linear" });
        gsap.to(this.pon.position, { duration: 1, x: this.pon.startx, y: this.pon.starty, z: this.pon.startz, delay: 0, ease: "sine.inOut" });
        gsap.to(this.pon.rotation, { duration: 1, x: this.e.u.ca(0), delay: 0, ease: "sine.out" });
        gsap.to(this.pon.scale, { duration: 1, x: .1, y: .1, z: .1, ease: "sine.out" });
        
        this.action="pon wait3"

      }else if(this.action==="pon wait3"){

        if(this.isPaused===false){
          this.count+=this.e.dt;
        }

        if(this.count>3){

          this.count=0;
          this.action="em"

        }

        //-------------------------------------------------------------------------------------------------------------------------------------

      }else if(this.action==="em"){

        this.energyMonitor.position.y=0;
        this.energyMonitor.position.z=6;

        gsap.to(this.energyMonitor.position, { duration: 1, z: 10, ease: "sine.inOut" });
        gsap.to(this.energyMonitor.rotation, { duration: 1, x: this.e.u.ca(20), ease: "sine.out" });

        this.myTextLabel.innerHTML = "Energy Monitor";

        gsap.to(this.darkPlane2.material, { duration: 1, delay: .5, opacity: 0.95, ease: "linear" });
        //gsap.to(this.myTextLabel, { duration: .25, delay: 1, opacity: 1, ease: "linear" });

        for(var i=0; i<this.emMaterials.length; i++){
          this.emMaterials[i].opacity = 0;
          gsap.to(this.emMaterials[i], { duration: .5, opacity: 1, ease: "linear" });
        }

        this.action="em wait"

      }else if(this.action==="em wait"){

        if(this.isPaused===false){
          this.count+=this.e.dt;
        }

        if(this.count>2){

          this.count=0;
          this.action="em2"
          
        }

      }else if(this.action==="em2"){

        this.energyMonitor.position.y=0;

        gsap.to(this.energyMonitor.rotation, { duration: this.innerRotTime, y: this.energyMonitor.rotation.y + this.e.u.ca(360), ease: "sine.inOut" });

        this.action="em wait2"

      }else if(this.action==="em wait2"){

        if(this.isPaused===false){
          this.count+=this.e.dt;
        }

        if(this.count>this.innerRotTime+1){

          this.buttonType="continue";
          this.buttonChange();
          
          this.count=0;
          this.action="em3"
          
        }

      }else if(this.action==="em3"){

        if(this.continuePress===true){

          this.continuePress=false;
          this.buttonType="pause";
          this.buttonChange();

          this.action="em3 out"

        }

      }else if(this.action==="em3 out"){

        gsap.to(this.darkPlane2.material, { duration: this.outTime, opacity: 0, ease: "linear" });
        //gsap.to(this.myTextLabel, { duration: this.outTime, opacity: 0, ease: "linear" });

        for(var i=0; i<this.emMaterials.length; i++){
          gsap.to(this.emMaterials[i], { duration: 0, opacity: 0, ease: "linear" });
        }

        this.action="em wait3"

      }else if(this.action==="em wait3"){

        if(this.isPaused===false){
          this.count+=this.e.dt;
        }

        if(this.count>2){

          this.buttonType="pause";
          this.buttonChange();

          this.count=0;
          this.action="qo"

        }

        //-------------------------------------------------------------------------------------------------------------------------------------

      }else if(this.action==="test qo"){


      }else if(this.action==="qo"){

        this.energyMonitor.position.z=0;
        this.energyMonitor.position.y=-1000;

        // this.qo.position.y=0;
        // this.qo.position.z=6;

        // for(var i=0; i<this.qoMaterials.length; i++){
        //   this.qoMaterials[i].opacity = 0;
        //   gsap.to(this.qoMaterials[i], { duration: .5, opacity: 1, ease: "linear" });
        // }

        gsap.to(this.qo.position, { duration: 1, x: 0, y: 0, z: 8, ease: "sine.inOut" });
        gsap.to(this.qo.rotation, { duration: 1, x: this.e.u.ca(0), ease: "sine.out" });

        // this.myTextLabel.innerHTML = "QO Placeholder";

        gsap.to(this.darkPlane2.material, { duration: 1, delay: .5, opacity: 0.95, ease: "linear" });
        // gsap.to(this.myTextLabel, { duration: .25, delay: 1, opacity: 1, ease: "linear" });

        this.action="qo wait"

      }else if(this.action==="qo wait"){

        if(this.isPaused===false){
          this.count+=this.e.dt;
        }

        if(this.count>2){

          this.count=0;
          this.action="qo2"
          
        }

      }else if(this.action==="qo2"){

        // this.qo.position.y=0;

        gsap.to(this.qo.rotation, { duration: this.innerRotTime, y: this.qo.rotation.y + this.e.u.ca(360), ease: "sine.inOut" });

        this.action="qo wait2"

      }else if(this.action==="qo wait2"){

        if(this.isPaused===false){
          this.count+=this.e.dt;
        }

        if(this.count>this.innerRotTime+1){

          this.buttonType="continue";
          this.buttonChange();

          this.count=0;
          this.action="qo3"
          
        }

      }else if(this.action==="qo3"){

        if(this.continuePress===true){

          this.continuePress=false;
          this.buttonType="pause";
          this.buttonChange();

          this.action="qo3 out"

        }

      }else if(this.action==="qo3 out"){

        gsap.to(this.darkPlane2.material, { duration: this.outTime, opacity: 0, ease: "linear" });
        // gsap.to(this.myTextLabel, { duration: this.outTime, opacity: 0, ease: "linear" });

        // for(var i=0; i<this.qoMaterials.length; i++){
        //   gsap.to(this.qoMaterials[i], { duration: this.outTime, opacity: 0, ease: "linear" });
        // }

        gsap.to(this.qo.position, { duration: 1, x: this.qo.startx, y: this.qo.starty, z: this.qo.startz, delay: 0, ease: "sine.inOut" });
        gsap.to(this.qo.rotation, { duration: 1, x: this.e.u.ca(0), delay: 0, ease: "sine.out" });
        // gsap.to(this.qo.scale, { duration: 1, x: .1, y: .1, z: .1, ease: "sine.out" });

        this.action="qo wait3"

      }else if(this.action==="qo wait3"){

        if(this.isPaused===false){
          this.count+=this.e.dt;
        }

        if(this.count>2){

          this.count=0;
          this.action="breaker"
          
        }

        //-------------------------------------------------------------------------------------------------------------------------------------

      }else if(this.action==="breaker"){

        // this.energyMonitor.position.z=0;
        // this.energyMonitor.position.y=-1000;

        gsap.to(this.breaker.position, { duration: 1, x: 0, y: 0, z: 10, ease: "sine.out" });
        gsap.to(this.breaker.rotation, { duration: 1, x: this.e.u.ca(20), ease: "sine.out" });
        gsap.to(this.breaker.scale, { duration: 1, x: .2, y: .2, z: .2, ease: "sine.out" });

        this.myTextLabel.innerHTML = "Breaker 20A";

        gsap.to(this.darkPlane2.material, { duration: 1, delay: .25, opacity: 0.95, ease: "linear" });

        this.action="breaker wait"

      }else if(this.action==="breaker wait"){

        if(this.isPaused===false){
          this.count+=this.e.dt;
        }

        if(this.count>2){

          this.count=0;
          this.action="breaker2"
          
        }

      }else if(this.action==="breaker2"){

        gsap.to(this.breaker.rotation, { duration: this.innerRotTime, y: this.breaker.rotation.y + this.e.u.ca(360), ease: "sine.inOut" });

        this.action="breaker wait2"

      }else if(this.action==="breaker wait2"){

        if(this.isPaused===false){
          this.count+=this.e.dt;
        }

        if(this.count>this.innerRotTime+1){

          this.count=0;
          this.action="breaker3"

          this.buttonType="continue";
          this.buttonChange();
          
        }

      }else if(this.action==="breaker3"){

        if(this.continuePress===true){

          this.continuePress=false;
          this.buttonType="pause";
          this.buttonChange();

          this.action="breaker3 out"

        }

      }else if(this.action==="breaker3 out"){

        gsap.to(this.darkPlane2.material, { duration: this.outTime, opacity: 0, ease: "linear" });
        gsap.to(this.breaker.position, { duration: 1, x: this.breaker.startx, y: this.breaker.starty, z: this.breaker.startz, delay: 0, ease: "sine.inOut" });
        gsap.to(this.breaker.rotation, { duration: 1, x: this.e.u.ca(0), delay: 0, ease: "sine.out" });
        gsap.to(this.breaker.scale, { duration: 1, x: .1, y: .1, z: .1, ease: "sine.out" });

        this.action="breaker wait3"

      }else if(this.action==="breaker wait3"){

        if(this.isPaused===false){
          this.count+=this.e.dt;
        }

        if(this.count>3){

          this.buttonType="pause";
          this.buttonChange();

          this.count=0;
          this.action="breaker60"
          
        }

        //-------------------------------------------------------------------------------------------------------------------------------------

      }else if(this.action==="breaker60"){

        // this.breaker.position.z=0;
        // this.breaker.position.y=-1000;

        // this.breaker60.position.y=0;
        // this.breaker60.position.z=6;

        // for(var i=0; i<this.breaker60Materials.length; i++){
        //   this.breaker60Materials[i].opacity = 0;
        //   gsap.to(this.breaker60Materials[i], { duration: .5, opacity: 1, ease: "linear" });
        // }

        gsap.to(this.breaker60.position, { duration: 1, x: 0, y: 0, z: 10, ease: "sine.out" });
        gsap.to(this.breaker60.rotation, { duration: 1, x: this.e.u.ca(20), ease: "sine.out" });
        gsap.to(this.breaker60.scale, { duration: 1, x: .2, y: .2, z: .2, ease: "sine.out" });

        this.myTextLabel.innerHTML = "Breaker 60A";

        gsap.to(this.darkPlane2.material, { duration: 1, delay: .25, opacity: 0.95, ease: "linear" });
        ////gsap.to(this.myTextLabel, { duration: .25, delay: 1, opacity: 1, ease: "linear" });

        this.action="breaker60 wait"

      }else if(this.action==="breaker60 wait"){

        if(this.isPaused===false){
          this.count+=this.e.dt;
        }

        if(this.count>2){

          this.count=0;
          this.action="breaker60 2"
          
        }

      }else if(this.action==="breaker60 2"){

        gsap.to(this.breaker60.rotation, { duration: this.innerRotTime, y: this.breaker60.rotation.y + this.e.u.ca(360), ease: "sine.inOut" });

        this.action="breaker60 wait2"

      }else if(this.action==="breaker60 wait2"){

        if(this.isPaused===false){
          this.count+=this.e.dt;
        }

        if(this.count>this.innerRotTime+1){

          this.count=0;
          this.action="breaker60 3"
          
          this.buttonType="continue";
          this.buttonChange();

        }

      }else if(this.action==="breaker60 3"){

        if(this.continuePress===true){

          this.continuePress=false;
          this.buttonType="pause";
          this.buttonChange();

          this.action="breaker60 3 out"

        }

      }else if(this.action==="breaker60 3 out"){

        gsap.to(this.darkPlane2.material, { duration: this.outTime, opacity: 0, ease: "linear" });
        gsap.to(this.breaker60.position, { duration: 1, x: this.breaker60.startx, y: this.breaker60.starty, z: this.breaker60.startz, delay: 0, ease: "sine.inOut" });
        gsap.to(this.breaker60.rotation, { duration: 1, x: this.e.u.ca(0), delay: 0, ease: "sine.out" });
        gsap.to(this.breaker60.scale, { duration: 1, x: .1, y: .1, z: .1, ease: "sine.out" });
        //gsap.to(this.myTextLabel, { duration: this.outTime, opacity: 0, ease: "linear" });

        // for(var i=0; i<this.breaker60Materials.length; i++){
        //   gsap.to(this.breaker60Materials[i], { duration: this.outTime, opacity: 0, ease: "linear" });
        // }

        this.action="breaker60 wait3"

      }else if(this.action==="breaker60 wait3"){

        if(this.isPaused===false){
          this.count+=this.e.dt;
        }

        if(this.count>3){

          this.count=0;
          this.action="out"
          
        }
        
        //-------------------------------------------------------------------------------------------------------------------------------------

      }else if(this.action==="out"){

        // this.breaker60.position.z=0;

        document.getElementById("pauseBut").style.pointerEvents = "none";
        gsap.to(document.getElementById("pauseBut"), { duration: this.tweenInSpeed/4, opacity: 0, ease: "linear" });

        // gsap.to(this.shadowBot.material, { duration: .5, delay: .5, opacity: 0.5, ease: "linear" });
        // gsap.to(this.shadowTop.material, { duration: .5, delay: .5, opacity: 0.5, ease: "linear" });

        gsap.to(this.frontDoor.rotation, { duration: .5, y: this.e.u.ca(0), ease: "sine.inOut" });
        gsap.to(this.pulsePanel.position, { duration: this.tweenInSpeed, delay: .5, x:2, z: -8, y: -2.5, ease: "sine.inOut" });
        gsap.to(this.pulsePanel.rotation, { duration: this.tweenInSpeed, delay: .5, y:this.e.u.ca(0), ease: "sine.inOut" });

        gsap.to(this.darkPlane.material, { duration: this.tweenInSpeed/2, opacity: 0, ease: "sine.inOut" });
        
        gsap.to(this.shadowPlane.material, { duration: (this.tweenInSpeed) - .25, delay: 1, opacity: .25, ease: "linear" });

        this.count=0;
        this.action="out wait 1";

      }else if(this.action==="out wait 1"){

        this.count+=this.e.dt;
        if(this.count>.32){

          this.breaker60.position.y=-1000;
          this.breaker.position.y=-1000;
          this.pon.position.y=-1000;
          this.qo.position.y=-1000;

          this.count=0;
          this.action="out wait";
  
        }
        
      }else if(this.action==="out wait"){

        this.count+=this.e.dt;
        if(this.count>this.tweenInSpeed){

          this.flange.material.opacity=0;

          this.pulsePanel.rotation.y = this.e.u.ca(0);
          this.count=0;
          this.action="wait";

        }

      }

      if(this.darkPlane.material.opacity===0){
        this.darkPlane.material.visible=false;
      }else{
        this.darkPlane.material.visible=true;
      }

      this.mixer()

    }

        //------------------------------------------------------------------

        

    mixer(){

      if(document.getElementById("mix").checked === true){
  
          //-------------------------------------
  
          var c1_H = document.getElementById("c1_H").value;
          var c1_S = document.getElementById("c1_S").value;
          var c1_L = document.getElementById("c1_L").value;
  
          document.getElementById("c1_Color").value = this.e.u.hslToHex(c1_H,c1_S,c1_L);
          this.changeMaterial.color.setHex( "0x"+this.e.u.hslToHex(c1_H,c1_S,c1_L) );
  
          //-------------------------------------
  
          var c2_H = document.getElementById("c2_H").value;
          var c2_S = document.getElementById("c2_S").value;
          var c2_L = document.getElementById("c2_L").value;
  
          document.getElementById("c2_Color").value = this.e.u.hslToHex(c2_H,c2_S,c2_L);
          // this.roofBars.material.color.setHex( "0x"+this.e.u.hslToHex(c2_H,c2_S,c2_L) );
          
          //-------------------------------------
  
          var c3_H = document.getElementById("c3_H").value;
          var c3_S = document.getElementById("c3_S").value;
          var c3_L = document.getElementById("c3_L").value;
  
          document.getElementById("c3_Color").value = this.e.u.hslToHex(c3_H,c3_S,c3_L);
          // this.roofEdge.material.color.setHex( "0x"+this.e.u.hslToHex(c3_H,c3_S,c3_L) );
          
          //-------------------------------------
  
          var c4_H = document.getElementById("c4_H").value;
          var c4_S = document.getElementById("c4_S").value;
          var c4_L = document.getElementById("c4_L").value;
  
          document.getElementById("c4_Color").value = this.e.u.hslToHex(c4_H,c4_S,c4_L);
          // this.ambLight.color.setHex( "0x"+this.e.u.hslToHex(c4_H,c4_S,c4_L) );
  
          //-------------------------------------
  
          var c5_H = document.getElementById("c5_H").value;
          var c5_S = document.getElementById("c5_S").value;
          var c5_L = document.getElementById("c5_L").value;
  
          document.getElementById("c5_Color").value = this.e.u.hslToHex(c5_H,c5_S,c5_L);
  
          //-------------------------------------
  
          var num1 = document.getElementById("num1").value;
          var num2 = document.getElementById("num2").value;
          var num3 = document.getElementById("num3").value;

          this.changeMaterial.metalness = num1/100;
          this.changeMaterial.roughness = num2/100;
  
          // this.dl_shad.position.x = num1;
          // this.dl_shad.position.z = num2;
          // this.dl_shad.position.y = num3;
  
      }

    }

}